export const EMPTY_FIELD_ERROR = "This field cannot be empty."
export const EMAIL_FORMAT_ERROR = "This email address is invalid. Please try again."
export const EMAIL_REGEXP =
  /^[a-z0-9A-Z!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9A-Z](?:[A-Za-z0-9-]*[a-z0-9A-Z])?\.)+[a-zA-Z]+$(?:[A-Za-z-]*[A-Za-z])?/
